import { getShipmentReportBNSF } from './BNSF/get_report';
import { getShipmentReportUPRR } from './UPRR/get_report';
import { getShipmentReportNS } from './NS/get_report';

const reportModal = $('#shipmentReportWindow');
const closeReport = $('#closeShipmentReport');

const tableUPRR = $('#tableUPRR');
const tableBNSF = $('#tableBNSF');
const tableNS = $('#tableNS');

const btnUPRR = $('#btnUprrReport');
const btnBNSF = $('#btnBnsfReport');
const btnNS = $('#btnNSReport');

const UPPRView = $('.uppr-report').first();
const BNSFView = $('.bnsf-report').first();
const NSView = $('.ns-report').first();


/**
 * Clear UPRR report list.
 */
function clearUPPRReport() {
  UPPRView.css('display', 'none');
  tableUPRR.text('');
  tableUPRR.prop('hidden', true);
}

/**
 * Clear BNSF report table.
 */
function clearBNSFReport() {
  BNSFView.css('display', 'none');
  tableBNSF.text('');
}

/**
 * Clear NS report list.
 */
function clearNSReport() {
  NSView.css('display', 'none');
  tableNS.text('');
  tableNS.prop('hidden', true);
}

/**
 * Get shipment report.
 *
 * @param {object} row - Record corresponding to the clicked row.
 */
export function showShipmentReport(row) {
  // Title for modal history window
  $('#shipmentReportTitle').text(`Shipment ${row.trace} report`);

  reportModal.modal('show');

  btnUPRR.on('click', () => {
    clearBNSFReport();
    clearNSReport();
    $('#uprrReportSpinner').attr('hidden', false);
    closeReport.prop('disabled', true);

    getShipmentReportUPRR(row);
    UPPRView.css('display', 'block');
  });

  btnBNSF.on('click', () => {
    clearUPPRReport();
    clearNSReport();
    $('#bnsfReportSpinner').attr('hidden', false);
    closeReport.prop('disabled', true);

    BNSFView.css('display', 'block');
    getShipmentReportBNSF(row);
  });

  btnNS.on('click', () => {
    clearUPPRReport();
    clearBNSFReport();
    $('#nsReportSpinner').attr('hidden', false);
    closeReport.prop('disabled', true);

    getShipmentReportNS(row);
    NSView.css('display', 'block');
  });
}

reportModal.on('hidden.bs.modal', () => {
  // Clear tables
  clearBNSFReport();
  clearUPPRReport();
  clearNSReport();

  // Delete error text
  $('#history_error_text').text('');

  // Delete info text
  $('#infoBnsfText').text('');
  $('#infoUprrText').text('');
  $('#infoNSText').text('');

  // Hide headers
  $('#headerUPRR').removeClass('d-flex');
  $('#headerBNSF').removeClass('d-flex');
  $('#headerNS').removeClass('d-flex');

  btnBNSF.off('click');
  btnUPRR.off('click');
  btnNS.off('click');
});


/**
 * Show estimated and confirmed DateTime for Revised ETA.
 *
 * @param {object} row - Record corresponding to the clicked row.
 */
export function showNotificationDate(row) {
  if (row.additional_data) {
    // Set DateTime for Revised ETA modal
    $('#estimated').text(
      `Estimated notification: ${row.additional_data.estimated_notification}`
    );
    $('#confirmed').text(
      `Confirmed notification: ${row.additional_data.confirmed_notification}`
    );

    $('#shipmentRevisedWindow').modal('show');
  }
}
